import ProfileUserInfo from './ProfileUserInfo';

export default ProfileUserInfo;